export const Url = {
    welcome: "/app1/welcome",
    signIn: "/app1/converter",
    signOut: "/", // go to home screen after sign-out
};
//# sourceMappingURL=defaults.js.map